<template>
  <div class="montant-selection-adhesion">
    <div>
      <div class="body-1 strong mb-6">Montant et catégorie de l'adhésion:</div>
      <div v-if="!loading">
        <v-chip-group id="montantSimple" ref="montantDonSimple" mandatory column v-model="montantAdhesionIndex">
          <v-chip v-for="montant in montantsAdhesions" :key="montant.t" x-large label outlined class="pa-6 categorie">
            <div class="text-center">
              <div class="font-weight-bold">{{ montant.code }} $</div>
              <div class="caption">
                {{ montant.t }}
              </div>
            </div>
          </v-chip>
        </v-chip-group>
      </div>
      <div v-else class="text-center my-6">
        <v-progress-circular indeterminate :size="50"></v-progress-circular>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex"
export default {
  data() {
    return {
      montantAdhesionIndex: 1,
      loading: true
    }
  },
  computed: {
    ...mapGetters({
      montantsAdhesions: "getMontantsAdhesionPossibles"
    })
  },
  watch: {
    montantAdhesionIndex() {
      this.updateMontantStore()
    }
  },
  methods: {
    ...mapMutations(["setMontantAdhesion", "setCategorieAdhesion"]),
    ...mapActions(["loadMontantsAdhesion"]),
    updateMontantStore() {
      this.setMontantAdhesion(parseInt(this.montantsAdhesions[this.montantAdhesionIndex].code))
      this.setCategorieAdhesion(this.montantsAdhesions[this.montantAdhesionIndex].v)
    }
  },
  async mounted() {
    await this.loadMontantsAdhesion()
    this.updateMontantStore()
    this.loading = false
  }
}
</script>

<style>
.adhesion-form .categorie {
  width: 90%;
  max-width: 350px;
  margin: auto;
  margin-bottom: 10px;
  justify-content: center;
}
</style>